import React, { Ref } from 'react'
import { TextField } from '@dasa-health/components-react'
import { FieldHookConfig, useField } from 'formik'
import { useSignUpAnaytics } from 'hooks/useSignUpAnaytics'
import { useLocation } from 'react-router-dom'

type FormikCustomFieldProps = {
    label: string
    inputMode?: string
    className?: string
    dataTestId?: string
    inputRef?: Ref<HTMLInputElement> | undefined
    handleChange?: React.ChangeEventHandler<HTMLInputElement>
    mask?: (v: string) => string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
} & FieldHookConfig<any>

export const FormikCustomField = ({
    label,
    inputMode,
    className,
    dataTestId,
    inputRef,
    disabled,
    value,
    handleChange,
    mask = v => v,
    ...props
}: FormikCustomFieldProps) => {
    const [field, meta] = useField(props)

    const inputDisabled = {
        color: '#AAAAAA',
        backgroundImage: 'linear-gradient(white 1%, #ededed',
    }
    const { dispatchAnalyticsEvent } = useSignUpAnaytics()
    const { pathname } = useLocation()
    const nameEvent = (pathName: string) => {
        if (pathName === '/recuperar-senha') {
            return 'reset_password'
        }
        return 'cadastro_web'
    }

    return (
        <>
            <TextField
                className={className ?? 'form__personal-data__field'}
                data-testid={dataTestId}
                disabled={disabled}
                helperText={meta.touched && meta.error ? meta.error : ''}
                inputMode={inputMode}
                label={label}
                name={props.name}
                onBlur={e => {
                    field.onBlur(e)
                    dispatchAnalyticsEvent('personalDataOnFieldBlur', {
                        name: nameEvent(pathname),
                        fieldName: e.target.name,
                        errorMessage: meta.error,
                    })
                }}
                onChange={e => {
                    e.target.value = mask(e.target.value)
                    field.onChange(e)
                }}
                ref={inputRef}
                style={disabled ? inputDisabled : {}}
                type={props.type}
                value={value ?? field.value}
                variant={meta.touched && meta.error ? 'error' : undefined}
            />
        </>
    )
}
